<div class="page-overlay">
  <div class="h-100 row align-items-center justify-content-center {{bgColorText}}">
    <div class="spinner-border text-white" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>

